"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NotificationsMenu = void 0;
var ToggleMenuFlyout = _interopRequireWildcard(require("@ori-events/toggle-menu-flyout"));
var _mui = require("@ori-ui/mui");
var _i18n = require("@ori/i18n");
var _logger = require("@ori/logger");
var _testidGenerator = require("@ori/testid-generator");
var _react = require("react");
var _ApiProvider = require("./components/ApiProvider");
var _NotificationMenuContent = require("./components/NotificationMenuContent");
var _defaultTranslations = require("./constants/defaultTranslations");
var _logger2 = require("./logger");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const OverlayBox = (0, _mui.styled)(_mui.Box)(() => ({
  position: 'absolute',
  left: '0',
  right: '0',
  top: '0',
  bottom: '0',
  zIndex: 800
}));
const useVisibility = () => {
  const [isVisible, setIsVisible] = (0, _react.useState)(false);

  // Visibility is managed from outside too (with events)
  (0, _react.useEffect)(() => {
    const toggleMenu = event => {
      if (event.detail.menuType === ToggleMenuFlyout.MenuTypes.Notifications) {
        setIsVisible(prev => !prev);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener(ToggleMenuFlyout.Name, toggleMenu);
    return () => {
      window.removeEventListener(ToggleMenuFlyout.Name, toggleMenu);
    };
  }, []);
  const close = (0, _react.useCallback)(() => setIsVisible(false), []);
  return [isVisible, {
    close
  }];
};
const NotificationsMenu = () => {
  const [isVisible, {
    close
  }] = useVisibility();
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_logger.LoggerProvider, {
    logger: _logger2.mainLogger,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_logger.ErrorBoundary, {
      areaName: "NotificationMenu",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_testidGenerator.TestIdProvider, {
        team: _testidGenerator.Team.Growth,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ApiProvider.ApiProvider, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_i18n.TranslationsNamespaceProvider, {
            namespace: _defaultTranslations.translationsNamespace,
            children: [isVisible ? /*#__PURE__*/(0, _jsxRuntime.jsx)(OverlayBox, {
              onClick: close
            }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Fade, {
              timeout: 300,
              in: isVisible,
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Box, {
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_NotificationMenuContent.NotificationMenuContent, {
                  isVisible: isVisible
                })
              })
            })]
          })
        })
      })
    })
  });
};
exports.NotificationsMenu = NotificationsMenu;
